import home from './home/en'

export default {
  home,
  // 公共部份
  switchLanguage: "Language switch to english",
  English: "中文",
  data: "Data",

  // Dashboard
  logo: "i-Analytics",
  toAdmin: "Admin",
  toOldVersion: "Old Version",
  toHome: "Official Website",
  intoSystem: "Into System",
  viewDetail: "View Detail",
  entrance: "Entrance",
  summary: "Summary",
  customSolution: "Custom Solution",

  expiration_date_remaining: "Expiration date remaining",
  view: "View",
  use_frequently: "Use frequently",
  bingWechat: "Bing Wechat",
  bingWechatTips:
    "After binding WeChat, you can scan the code to log in quickly",
  userCenter: "User center",
  panelSetting: "Panel setting",
  theme: "Theme",
  logout: "Logout",
  homeTitle: "Home",
  doesNotSupport: "Your browser does not support the video tag.",

  // 车型速览
  fastview: "Search",
  competitorCompare: "竞品对比",

  searchPlaceholder: "Enter model name",
  searchEmpty: "No relevant content~",
  searchPlaceholder2: "搜索车型",
  latestNews: "Industry News",
  industryPolicy: "Industry Policy",
  effectiveDate: "实施日期",
  detailCompare: "详细对比",
  lifeCycle: "生命周期",

  // 用户中心
  switchAccount: "Switch account",
  collapseAccount: "Collapse account",
  loginInfo: "Login info",
  bindingDescription:
    "Once bound, you can log in with your mobile phone number, email address or WeChat scan code",
  mobileNo: "Mobile No.",
  email: "Email",
  wechat: "Wechat",
  wechatDescription: "WeChat binding",
  bind: "Bind now",
  currentAccount: "Current account",
  switchToThisAccount: "Switch to this account",
  expired: "Expired",

  // 绑定手机邮箱
  bindOrEdit: "bing/edit",
  input: "Please input ",
  vertifyCode: "Vertify code",
  get: "Get ",
  confirm: "Confirm",
  cancel: "Cancel",
  mobileMessage: "Please enter the correct phone number",
  emailMessage: "Please enter the correct email address",
  vertifyMessage:
    "The verification code is entered incorrectly, please re-enter it",
  bindSuccess: "The binding was successful",
  bindFail: "The binding failed",

  // 面板配置
  panelSettingTips: "Team up to create your own console (up to 3 optional)",
  selected: "Selected",
  dragToAdjustSort: "Drag to adjust the sort",

  clickToApply: "Request a trial",
  applyFormProduct: "Apply for a trial product",
  applyFormComfirm: "Are you sure you want to apply for trial [{product}] ?",
  // 菜单数据
  chimiLogoData: [
    {
      value: "智见OTA",
      label: "i-See OTA",
      href: "https://iev.way-s.cn/ota"
    },
    {
      value: "智见分晓",
      label: "i-See Intelligence",
      href: "https://iev.way-s.cn/intelligent"
    },
    {
      value: "智见权益",
      label: "i-See Benefits",
      href: "https://iev.way-s.cn/promotion"
    },
    {
      value: "智见洞察",
      label: "Industry Insight",
      href: "https://iev.way-s.cn/insight"
    }
  ],
  panels: {
    switchDataSource: "DataSource",
    switchSegment: "Segment",
    tableData: "Table Data",
    DATASOURCE_CLH_PIFA: "CLH_PIFA",
    DATASOURCE_CLH_SALES: "CLH_SALES",
    DATASOURCE_ZD_LINGSHOU: "ZD_LINGSHOU",
    VehicleMarket: "Vehicle Market",
    NewEnergyMarket: "NewEnergy Market",
    year: "",
    yoy: "Yoy",
    mom: "Mom",
    rank: "Rank",
    manf: "Manf",
    model: "Model",
    sales: "Sales",
    salesYoy: "Sales yoy",
    salesMom: "Sales mom",
    salesShare: "Sales share",
    shareYoy: "Share yoy",
    msrp: "Msrp",
    forePrice: "Fore price",
    wan: "10 Thousand",

    IndustryTrend: {
      title: "Industry Trend",
      more: "More",
      news: "Zhijian Dongcha",
      policy: "Policy"
    },
    WholeMarketSales: {
      title: "Sales"
    },
    ManfSalesRankTop10: {
      title: "Manf sales"
    },
    MarketPriceIndex: {
      title: "Market price index"
    },
    ModelSalesRankTop10: {
      title: "Model sales"
    },
    NewCarInfo: {
      title: "New car info",
      onSale: "On sales",
      foreSale: "Coming soon model",
      have: "There are",
      newCarOnSales: "new car on sales",
      newCarForeSales: "new car coming soon"
    }
  },
  filters: {
    level1: "Leve 1",
    level2: "Leve 2",
    level3: "Leve 3",
    level4: "Leve 4",
    thisProduct: "This Product",
    competitiveCircle: "Competitive Circle",

    Favorites: "Favorites",
    CustomFolder: "Custom Folder",
    Select: "Select",
    competitorSet: "竞品设置",
    competitorCreate: "新建竞品组",
    competitorDelete: "确认要删除该竞品组？"
  },
  common: {
    tips: "Tips",
    query: "Query",
    reset: "Reset",
    cancel: "Cancel",
    create: "Create",
    edit: "Edit",
    save: "Save",
    confirm: "Confirm",
    action: "Action",
    delete: "Delete",
    copy: "Copy",
    NoData: "No Data",
    pin: "Pin",
    unpin: "Unpin",
    total: "Total",
    totalItems: "Total {0} items",
    rank: "Rank",
    rankRange: "Rank range",
    trend: "Trend",
    vol: "Vol",
    volYtd: "YTD Vol",
    gr: "G/R",
    grYoy: "G/R YOY",
    grMom: "G/R MOM",
    gsYtd: "G/R YTD",
    ms: "M/S",
    msYoy: "M/S YOY",
    msMom: "M/S MOM",
    msChange: "M/S Change",
    msChangeYtd: "M/S YTD Change",
    change: "Change",
    dimension: "Dimension",
    dataSource: "Data source",
    datatime: "Period",
    dateTypeM: "Monthly",
    dateTypeQ: "Quarterly",
    dateTypeY: "Annually",
    fuelType: "Fuel Type",
    manfType: "OEM Type",
    manfBrndType: "Origin Type",
    luxuryType: "Luxury Type",
    manf: "OEM",
    brand: "Brand",
    origin: "Origin",
    submodel: "Model",
    submodelPerformance: "Model Performance",
    segment: "Segment",
    tier: "Tier",
    region: "Region",
    manfBrand: "OEM Brand",
    regionCountryArea: "Areas",
    regionCountryProvince: "Provinces",
    regionCountry: "Nationwide",
    regionArea: "Area",
    regionProvince: "Province",
    regionCity: "City",
    shareIndicator: "Share Indicator",
    shareIndicatorOpt: "Of segment level {0}",
    intersectionType: "Intersection Type",
    analysisType: "Analysis Type",
    any: "Any",
    all: "All",
    toTop: "To top",
    selectPls: "Select please",
    maxMonthRange: "Select time range no more than {0} months",
    maxQuarterRange: "Select time range no more than {0} quarters",
    maxYearRange: "Select time range no more than {0} years",
    dataLabel: "Data labels",
    unit: "Unit",
    dateRange: "Date range",
    pastDateRange: "Past {0} years",
    allDateRange: "All years",
    indicator: "Indicator",
    chartTranspose: "Transpose",
    tableColSetting: "Columns setting",
    outOfRange: "Out of range",
    na: "N/A",
    compareManf: "Compare OEMs",
    compareBrand: "Compare brands",
    compareSubmodel: "Compare models",
    imported: "Imported",
    domestic: "Domestic",
    cityLimtTyp: "City restriction type",
    cityLimtTypOptions: [
      { value: "1", label: "Traffic control and purchase restriction" },
      { value: "2", label: "Traffic control but no purchase restriction" },
      { value: "3", label: "No traffic control but with purchase restriction" },
      { value: "4", label: "No traffic control nor purchase restriction" }
    ]
  }
};
